export const compareTeamsByDefaultAndName = <
  T extends { default: boolean; name: string; orderInGuild: number },
>(
  a: T,
  b: T,
) => {
  if (a.orderInGuild !== b.orderInGuild) return a.orderInGuild - b.orderInGuild
  if (a.default !== b.default) return a.default ? -1 : 1

  return a.name.localeCompare(b.name)
}
